import wrapWithProvider from "./wrap-with-provider";
import './src/styles/app.css'
export const wrapRootElement = wrapWithProvider;
